import templateUrl from 'emun.vendor/vendorgroup-dashboard-toolbar.htm'
import controller from 'emun.vendor/vendorgroup-dashboard.controller'

export default {
	bindings: {
		vendor: '<'
	},
	controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};